/*eslint-disable*/

import { removeEmptyProperties } from "../../helpers/general"

const addNameToUserDTO = (user, userDTO) => {
  const { firstName, lastName } = user;
  userDTO.name = {
    givenName: firstName,
    familyName: lastName,
  };
}

const addEmailsToUserDTO = (user, userDTO) => {
  const { email } = user;
  userDTO.emails = [
    {
      type: "work",
      value: email,
      primary: true,
    },
  ]
}

const addPhoneNumbersToUserDTO = (user, userDTO) => {
  const { phoneNumber } = user;
  if(phoneNumber) {
    userDTO.phoneNumbers = [
      {
        type: "mobile",
        value: phoneNumber.replace(/\(|\)/g, ""),
      },
    ];
  }
}

const addAddressesToUserDTO = (user, userDTO) => {
  const { country } = user;
  if(country) {
    userDTO.addresses = [
        {
          country: country.slice(0, 2),
        },
      ]
  }
}

const addLocaleToUserDTO = (user, userDTO) => {
  const {  locale } = user;
  if(locale) {
    userDTO.locale = locale;
  }
}

const addGroupsToUserDTO = (user={}, userDTO) =>  {
  const { groups } = user;
  if(groups?.length>0) {
    userDTO.groups =  groups?.map(group => group?.value)
  } else {
    userDTO.groupsOverride = true
  }
}

const addDomainNameToUserDTO = (user={}, userDTO) =>  {
  const { domainName } = user;
  if(domainName) {
    userDTO.domainName = domainName;
    userDTO.sendActivationEmail = true;
  }
  
}

const addPreferredLanguageToUserDTO = (userDTO, user={}) => {
  const { preferredLanguage } = user
  if (preferredLanguage) {
    userDTO.preferredLanguage = preferredLanguage
  }
}

const addCustomAttributesToUserDTO = (user = {}, userDTO, customAttributes = []) => {
  customAttributes.forEach(({ label }) => {
    if (user[label] !== undefined && user[label] !== '') {
      userDTO[label] = user[label]
    }
  })
}

export const makeCreateUserDTO = (user = {}, customAttributes = []) => {
  const userDTO = {
    schemas: '["urn:ietf:params:scim:schemas:core:2.0:User"]',
  }
  addDomainNameToUserDTO(user, userDTO)
  addGroupsToUserDTO(user, userDTO)
  addNameToUserDTO(user, userDTO)
  addEmailsToUserDTO(user, userDTO)
  addPhoneNumbersToUserDTO(user, userDTO)
  addAddressesToUserDTO(user, userDTO)
  addLocaleToUserDTO(user, userDTO)
  addPreferredLanguageToUserDTO(userDTO, user)
  addCustomAttributesToUserDTO(user, userDTO, customAttributes)
  return [userDTO]
}

export const getSelectedGroupsCount = (selectedGroups=[]) => {
  return selectedGroups.length
}

export const getCustomAttributeDefaults = (customAttributes = []) =>
  customAttributes.reduce((defaults, { label, default: defaultValue }) => {
    if (defaultValue !== undefined && defaultValue !== null && defaultValue !== '') {
      defaults[label] = defaultValue
    }
    return defaults
  }, {})

// Pre-filled defaults alone should not count as user changes
export const areFormValuesChanged = (user={}, defaults={}) => {
  const changedValues = Object.entries(removeEmptyProperties(user))
    .filter(([key, value]) => defaults[key] !== value)
  if(changedValues.length>0) {
    return true;
  }
  return false;
}
